const LEGACY_SECTION_KEY_ALIASES: Record<string, string> = {
    "allergies,_adverse_reactions,_alerts": "allergies",
    functional_status: "functional_statuses",
    history_of_encounters: "encounters",
    history_of_immunizations: "immunizations",
    history_of_medication_use: "medications",
    history_of_procedures: "procedures",
    payer: "payers",
    plan_of_care: "care_plan",
    plan_of_treatment: "care_plan",
    problem_list: "problems",
    "relevant_diagnostic_tests_and/or_laboratory_data": "results",
    treatment_plan: "care_plan",
    vital_signs: "vitals"
};

interface LegacyCdaPreferences {
    enabledSectionKeys?: unknown;
    sortedSectionKeys?: unknown;
}

export const migrateLegacyCdaPreferences = (): void => {
    const legacyKeys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key?.startsWith("doc_")) legacyKeys.push(key);
    }

    for (const legacyKey of legacyKeys) {
        const targetKey = `cda-preferences.${legacyKey.slice("doc_".length)}`;
        const legacy = parse(localStorage.getItem(legacyKey));

        if (!localStorage.getItem(targetKey) && Array.isArray(legacy?.enabledSectionKeys) && Array.isArray(legacy.sortedSectionKeys)) {
            localStorage.setItem(
                targetKey,
                JSON.stringify({
                    enabledSectionKeys: canonicalSectionKeys(legacy.enabledSectionKeys),
                    sortedSectionKeys: canonicalSectionKeys(legacy.sortedSectionKeys)
                })
            );
        }

        localStorage.removeItem(legacyKey);
    }
};

const canonicalSectionKeys = (keys: unknown[]): string[] => [
    ...new Set(keys.filter((key): key is string => typeof key === "string").map((key) => LEGACY_SECTION_KEY_ALIASES[key] ?? key))
];

const parse = (json: string | null): LegacyCdaPreferences | null => {
    try {
        return JSON.parse(json ?? "null") as LegacyCdaPreferences | null;
    } catch {
        return null;
    }
};
